const heightController = () => {
  $( '.download-list.desktop .documentation-image' ).each( function() {
    let tab = $( this );
  
    tab.on('click', function() {
      if(tab.hasClass('.documentation-image.active')) {
        return;
      }

      tab.parent().parent().find('.documentation-type .documentation-image.active').each(function(){
        $( this ).attr( 'style', 'padding-bottom: 0px' );
        $( this ).attr( 'style', 'margin-bottom: 0px' );
        $( this ).removeClass("active");
      });
      tab.addClass("active");
      let name = tab.find( '.documentation__products' );
      let height = 0;
      if(name.length != 0) {
        height = name.height();
      }
      tab.attr( 'style', 'padding-bottom:' + height + 'px' );
    });
  });

  $( '.general-icon.General' ).each( function() {
    
    let tab = $( this ).parent();

    tab.on('click', function() {
      if(tab.hasClass('.documentation-image.active')) {
        return;
      }

      tab.parent().parent().find('.documentation-type .documentation-image.active').each(function(){
        $( this ).attr( 'style', 'padding-bottom: 0px' );
        $( this ).attr( 'style', 'margin-bottom: 0px' );
        $( this ).removeClass("active");
      });

      let name = tab.find( '.general-resource-group' );
      let height = 0;

      if(name.length != 0) {
        height = name.height();
      }
      tab.addClass("active");
      tab.attr( 'style', 'padding-bottom:' + height + 'px' );
    });
  });

  $( '.download-list.desktop .documentation-image .product-item' ).each( function() {
    let tab = $( this );

    tab.on('click', function() {
      if(tab.hasClass('.active')) {
        return;
      }
      tab.parent().find('.product-item.active').each(function(){
        $( this ).attr( 'style', 'padding-bottom: 0px' );
        $( this ).attr( 'style', 'margin-bottom: 0px' );
        $( this ).removeClass("active");
      });
      tab.addClass("active");
      let name = tab.find( '.resource-group' );
      let height = 0;

      if(name.length != 0) {
        height = name.height() + 60;
      }

      
      tab.attr( 'style', 'margin-bottom:' + height + 'px' );
    });
  });

};

$( document ).ready( function() {
    heightController();

    $(document).on('click', function (e) {
      if ($(e.target).closest(".download-list.desktop").length === 0) {
        let tab = $( ".download-list.desktop" );
        tab.find('.active').each(function(){
          $( this ).attr( 'style', 'padding-bottom: 0px' );
          $( this ).attr( 'style', 'margin-bottom: 0px' );
          $( this ).removeClass("active");
        });
      }
  });
});

